import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { Card } from 'commons-ui';
import { useStyletron } from 'baseui';
import usePermission from 'routes/usePermission';
import useACLPermission from 'commons-ui/src/permission/usePermission';
import { ACL_ENTITIES, DASHBOARD_RESOURCES, Entity, PAGE_NAMES } from 'constant';

import { URL, LABEL, IMAGE_SOURCE } from './helper';

const useDashboardHome = () => {
	const { hasPermission } = usePermission();
	const { hasPermission: hasACLPermission } = useACLPermission();

	const isEnabled = (entity: Entity) => {
		if (ACL_ENTITIES.includes(entity)) {
			return hasACLPermission({
				configPageName: PAGE_NAMES.dashboard,
				configResourceName: entity
			});
		}
		return hasPermission({
			configPageName: PAGE_NAMES.dashboard,
			entity
		});
	};

	return { isEnabled };
};

const DashboardHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useDashboardHome();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-evenly',
				alignItems: 'center',
				height: '100%',
				'overflow-y': 'scroll',
				flexWrap: 'wrap',
				gap: '50px'
			})}>
			{_map(_keys(DASHBOARD_RESOURCES), (entity: Entity) => {
				return isEnabled(entity) ? (
					<div
						key={entity}
						className={css({
							height: '130px',
							width: '30%',
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-around'
						})}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							// for specific entities whose url is external
							if ([DASHBOARD_RESOURCES.ruleEngine, DASHBOARD_RESOURCES.tournamentV2].includes(entity)) {
								window.open(URL[entity], '_blank');
							} else {
								history.push(URL[entity]);
							}
						}}>
						<Card label={LABEL[entity]} img={IMAGE_SOURCE[entity]} />
					</div>
				) : null;
			})}
		</div>
	);
};

export default DashboardHome;
